<script setup lang="ts">
import SearchSelectLifetimeTable from "./SearchSelectLifetimeTable.vue";

const props = defineProps<{
  parents: string[];
  materialGroupings: string[];
  selectedMat: string;
  selectedStruc: string;
}>();

const emits = defineEmits(["selectMaterial", "selectStructure", "resetTable"]);

const handleSetMaterial = (material: string) => {
  emits("selectMaterial", material);
};
const handleSetStructure = (structure: string) => {
  emits("selectStructure", structure);
};
const handleEmitReset = () => {
  emits("resetTable", true);
};
</script>

<template>
  <div class="flex w-full items-end gap-4">
    <SearchSelectLifetimeTable
      :key="props.selectedStruc + props.selectedMat"
      :value="props.selectedStruc"
      placeholder="Structures"
      :options="props.parents"
      @option-selected="handleSetStructure" />
    <SearchSelectLifetimeTable
      :key="props.selectedMat + props.selectedStruc"
      :value="props.selectedMat"
      placeholder="Material"
      :options="props.materialGroupings"
      @option-selected="handleSetMaterial" />
    <button
      type="button"
      class="focus-ring interactive-active t-small-bold rounded-8 bg-slate-0 text-type-default duration-fast ease-standard border border-slate-200 px-4 py-2 whitespace-nowrap transition-colors hover:bg-slate-100"
      @click="handleEmitReset">
      Reset table
    </button>
  </div>
</template>
